/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import styles from './AppAvatar.module.scss';
import AvatarBadge from './AvatarBadgeDashboard';
import { ReactComponent as ArrowUp } from '../../assets/svg/arrow-up.svg';
import { ReactComponent as ArrowDown } from '../../assets/svg/arrow-down.svg';
import { ReactComponent as Present } from '../../assets/svg/present-icon.svg';
import { ContactSupportModal, KycModal } from '../../../tt-modals';
import { ANTD_COMPONENTS, Collapse } from 'tt-ui-lib/core';
import { ANTD_ICONS } from 'tt-ui-lib/icons';
import { useWindowSize } from '../../utils/useWindowSize';
import AvatarDrawer from './Drawer';
import { getAvatarPathBySize } from '../../utils/common';
import { useNavigate } from 'react-router';

const { Avatar } = ANTD_COMPONENTS;
const { TeamOutlined } = ANTD_ICONS;
const AppAvatar = ({
  children,
  size = 40,
  selectedCompany,
  userName,
  role,
  nav,
  logOut,
  logoutUserHandler,
  openOptions,
  arrowButton,
  selectProfile,
  selectSettings,
  selectHelp,
  userCompanies,
  selectCompany,
  selectToPersonalProfile,
  selectValidatorAgreement,
  user,
  mainTTUrl,
  marketTTUrl,
  digitalAssetsTTUrl,
  onAvatarClick,
  onClickShowProfile = false,
  mode,
  selectSavedFolders,
  selectArchived,
  selectReferral,
  selectRole,
  ...props
}) => {
  const fontSizes = {
    xs: '12px',
    xl: '12px',
    sm: '12px',
    md: '16px',
    lg: '42px',
  };

  const helpMenu = [
    { name: 'Tutorial', href: 'tutorials' },
    { name: 'Presentations', href: 'presentations' },
    { name: 'Q&A', href: '' },
  ];

  const menu = [
    { name: 'About', href: 'about' },
    { name: 'How does it work?', href: 'work' },
    { name: 'Privacy Policy', href: 'privacy-policy' },
    { name: 'Honor code', href: 'honor' },
    { name: 'Terms of Services', href: 'terms' },
    { name: 'SDGs', href: 'sdgs' },
  ];

  const endpointQA = process.env.REACT_APP_QA || '';

  // const [openCollapse, setOpenCollapse] = useState(false);
  // const [openCollapseMenu, setOpenCollapseMenu] = useState(false);
  // const [openCollapseHelp, setOpenCollapseHelp] = useState(false);
  const [visOption, setVisOption] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isKycModelOpen, setIsKycModalOpen] = useState(false);
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const [isIndividual, setIsIndividual] = useState(true);

  const dropdownRef = useRef();
  const windowSize = useWindowSize();
  const navigate = useNavigate();

  const onChangeOpen = () => {
    if (windowSize.width > 1024) {
      setVisOption((value) => !value);
    } else {
      setOpenDrawer(true);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setVisOption(false);
    }
  };

  const selectPassKYC = () => {
    onChangeOpen();
    setIsKycModalOpen(true);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (user?.roles && user?.roles.length) {
      const roleExpert = user?.roles?.find((elem) => elem.name === 'expert');
      const roleBusiness = user?.roles?.find((elem) => elem.name === 'business');
      const roleInvestor = user?.roles?.find((elem) => elem.name === 'investor');
      if (roleExpert || roleBusiness || roleInvestor) {
        setIsIndividual(false);
      } else {
        const roleHolder = user?.roles?.find((elem) => elem.name === 'holder');
        if (roleHolder) {
          setIsIndividual(false);
        } else {
          const roleIndividual = user?.roles?.find((elem) => elem.name === 'individual');

          if (roleIndividual) {
            setIsIndividual(true);
          } else {
            setIsIndividual(false);
          }
        }
      }
    }
  }, [user]);

  const initials = userName
    ? userName
        .split(' ')
        .map((i) => i[0])
        .join('')
    : '';

  const onSelectHelp = (item) => {
    if (item.name === 'Q&A') {
      window.location.replace(endpointQA);
    } else {
      window.location.replace(`${mainTTUrl || ''}/${item.href}`);
    }
  };

  const onSelectMenu = (item) => {
    window.location.replace(`${mainTTUrl || ''}/${item.href}`);
  };

  const onSelectSupport = () => {
    setIsSupportModalOpen(true);
  };

  const onSelectProfile = () => {
    if (selectedCompany?.isCompanySelected) {
      if (marketTTUrl)
        window.location.replace(
          `${marketTTUrl || ''}/dashboard/company/${selectedCompany.selectedCompany.id}/edit`
        );
      else navigate(`/dashboard/company/${selectedCompany.selectedCompany.id}/edit`);
    } else {
      console.log();
      if (mainTTUrl) window.location.replace(`${mainTTUrl || ''}/dashboard/profile/${user?.id}`);
      else navigate(`/dashboard/profile/${user?.id}`);
    }
  };

  const onSelectMyContent = () => {
    if (mainTTUrl) window.location.replace(`${mainTTUrl || ''}/dashboard/content`);
    else navigate('/dashboard/content');
  };

  return (
    <div>
      <div className={styles.avatarOverlay} ref={dropdownRef}>
        {nav === 2 && (
          <div className={styles.avatarRow}>
            <Avatar
              {...props}
              src={
                selectedCompany?.isCompanySelected
                  ? selectedCompany.selectedCompany.logos[0]?.path || ''
                  : user?.avatar
              }
              size={size || 40}
              style={{ cursor: onAvatarClick || onClickShowProfile ? 'pointer' : 'default' }}
              onClick={() => {
                if (onAvatarClick) {
                  onAvatarClick();
                } else if (onClickShowProfile) {
                  onSelectProfile();
                } else {
                  onChangeOpen();
                }
              }}
            >
              <>
                {children}
                {initials}
              </>
            </Avatar>
          </div>
        )}
        {nav === 1 && (
          <Avatar
            {...props}
            style={{
              cursor: onAvatarClick || onClickShowProfile ? 'pointer' : 'default',
              fontSize: `${fontSizes[size]} !important`,
              backgroundColor: 'primary.black-10',
              color: 'primary.black-80',
              fontWeight: '500',
            }}
            size={size || 40}
            onClick={() => {
              if (onAvatarClick) {
                onAvatarClick();
              } else if (onClickShowProfile) {
                onSelectProfile();
              } else {
                onChangeOpen();
              }
            }}
          >
            <>
              {children}
              {initials}
            </>
          </Avatar>
        )}
        {nav === 0 && (
          <Avatar
            {...props}
            src={
              props.src
                ? props.src
                : selectedCompany?.isCompanySelected
                  ? selectedCompany.selectedCompany.logos[0]?.path || ''
                  : user?.avatar
            }
            size={size || 40}
            style={{
              cursor: onAvatarClick || onClickShowProfile ? 'pointer' : 'default',
              fontSize: fontSizes[size],
              bgcolor: 'primary.black-10',
              color: 'primary.black-80',
              fontWeight: '500',
            }}
            onClick={() => {
              if (onAvatarClick) {
                onAvatarClick();
              } else if (onClickShowProfile) {
                onSelectProfile();
              } else {
                onChangeOpen();
              }
            }}
          >
            <>
              {children}
              {initials}
            </>
          </Avatar>
        )}
        {arrowButton === 1 && (
          <div
            className={styles.downArrowDiv}
            style={{ backgroundColor: `${visOption ? '#143471' : 'white'}` }}
            onClick={() => onChangeOpen()}
          >
            {!visOption ? (
              <ArrowDown className={styles.arrow} />
            ) : (
              <ArrowUp className={styles.arrowActive} fill="white" />
            )}
          </div>
        )}
        {role && (size === 63 || size === 56) && <AvatarBadge size={size} role={role} />}
        {openOptions === 1 && (
          <div hidden={!visOption} className={styles.dropdownBox}>
            <ul className={styles.dropdown} hidden={!visOption} aria-label="mailbox folders">
              <li
                className={styles.dropdownItem}
                onClick={() => {
                  onSelectProfile();
                  setVisOption(false);
                }}
              >
                {selectedCompany?.isCompanySelected ? 'Company profile' : 'Profile'}
              </li>
              <li
                className={styles.dropdownItem}
                onClick={() => {
                  onSelectMyContent();
                  setVisOption(false);
                }}
              >
                My Content
              </li>
              <li
                className={styles.dropdownItem}
                onClick={() => {
                  selectSavedFolders();
                  setVisOption(false);
                }}
              >
                Saved Folders
              </li>
              <li
                className={styles.dropdownItem}
                onClick={() => {
                  selectArchived();
                  setVisOption(false);
                }}
              >
                Archived
              </li>
              {!selectedCompany?.isCompanySelected && (
                <li
                  className={styles.dropdownItem}
                  onClick={() => {
                    selectRole();
                    setVisOption(false);
                  }}
                >
                  Change your role
                </li>
              )}
              {!selectedCompany?.isCompanySelected && (
                <li
                  className={styles.dropdownItem}
                  onClick={() => {
                    selectReferral();
                    setVisOption(false);
                  }}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <p style={{ marginRight: 10 }}>Referral program</p>
                  <Present />
                </li>
              )}
              <li
                className={styles.dropdownItem}
                onClick={() => {
                  selectSettings();
                  setVisOption(false);
                }}
              >
                Settings & security
              </li>

              <>
                {helpMenu && helpMenu.length > 0 && (
                  <li className={`${styles.dropdownNestedRoot} ${styles.dropdownItem}`}>
                    <Collapse
                      items={[
                        {
                          key: '1',
                          label: 'Help',
                          children: (
                            <div className={styles.dropdownBody}>
                              {helpMenu.map((item) => (
                                // eslint-disable-next-line react/jsx-key
                                <div
                                  className={styles.dropdownItemCompany}
                                  onClick={() => onSelectHelp(item)}
                                >
                                  <span>{item.name}</span>
                                </div>
                              ))}
                              <div onClick={onSelectSupport} className={styles.dropdownItemCompany}>
                                <span>Support</span>
                              </div>
                            </div>
                          ),
                        },
                      ]}
                      appearance="pure"
                      ghost
                    />
                  </li>
                )}
              </>
              <>
                {menu && menu.length > 0 && (
                  <li className={`${styles.dropdownNestedRoot} ${styles.dropdownItem}`}>
                    <Collapse
                      items={[
                        {
                          key: '1',
                          label: 'Menu',
                          children: (
                            <div className={styles.dropdownBody}>
                              {menu.map((item) => (
                                // eslint-disable-next-line react/jsx-key
                                <div
                                  className={styles.dropdownItemCompany}
                                  onClick={() => onSelectMenu(item)}
                                >
                                  <span>{item.name}</span>
                                </div>
                              ))}
                            </div>
                          ),
                        },
                      ]}
                      appearance="pure"
                      ghost
                    />
                  </li>
                )}
              </>
              {/* {user.role_name !== 'individual' && (
                <div className={styles.dropdownCollapse} onClick={(e) => onSelecetBusiness(e)}>
                  <li className={styles.dropdownItemCollapse}>Business account</li>
                  {openCollapse ? (
                    <div className={styles.dropdownArrowCollapse}>
                      <ExpandLess />
                    </div>
                  ) : (
                    <div className={styles.dropdownArrowCollapse}>
                      <ExpandMore />
                    </div>
                  )}
                </div>
              )} */}
              {selectedCompany?.isCompanySelected && (
                <li className={`${styles.dropdownItem}`} onClick={selectToPersonalProfile}>
                  Personal account
                </li>
              )}
              <>
                {userCompanies && userCompanies.length > 0 && (
                  <li className={`${styles.dropdownNestedRoot} ${styles.dropdownItem}`}>
                    <Collapse
                      items={[
                        {
                          key: '1',
                          label: 'Bussines account',
                          children: (
                            <div className={styles.dropdownBody}>
                              {userCompanies.map((item) => (
                                // eslint-disable-next-line react/jsx-key
                                <div
                                  className={styles.dropdownItemCompany}
                                  onClick={() => selectCompany(item)}
                                >
                                  {item.logos.length > 0 ? (
                                    <Avatar
                                      src={getAvatarPathBySize(item.logos, 'smallPath')}
                                      size={24}
                                      icon={
                                        <TeamOutlined
                                          style={{
                                            width: 20,
                                            height: 20,
                                            fontSize: 14,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                          }}
                                        />
                                      }
                                    />
                                  ) : (
                                    <Avatar
                                      size={24}
                                      icon={
                                        <TeamOutlined
                                          style={{
                                            width: 20,
                                            height: 20,
                                            fontSize: 14,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                          }}
                                        />
                                      }
                                    />
                                  )}
                                  <span>{item.company_name || item.companyName || '-'}</span>
                                </div>
                              ))}
                            </div>
                          ),
                        },
                      ]}
                      appearance="pure"
                      ghost
                    />
                  </li>
                )}
              </>

              {!isIndividual &&
                user?.kyc !== 'success' &&
                user?.kyc !== 'pending' &&
                user?.kyc !== 'created' && (
                  <li
                    className={styles.dropdownItem}
                    onClick={() => {
                      selectPassKYC();
                      setVisOption(false);
                    }}
                  >
                    Pass KYC
                  </li>
                )}

              <li
                className={styles.dropdownItem}
                onClick={() => {
                  logOut();
                  setVisOption(false);
                }}
              >
                Log out
              </li>
            </ul>
          </div>
        )}

        {openOptions === 1 && (
          <div className={styles.settingModal}>
            <AvatarDrawer
              isIndividual={isIndividual}
              open={openDrawer}
              onClose={() => setOpenDrawer(false)}
              logOut={logoutUserHandler}
              user={user}
              selectedCompany={selectedCompany}
              selectPassKYC={selectPassKYC}
              mainTTUrl={mainTTUrl}
              marketTTUrl={marketTTUrl}
              digitalAssetsTTUrl={digitalAssetsTTUrl}
              userCompanies={userCompanies}
              selectCompany={selectCompany}
              selectToPersonalProfile={selectToPersonalProfile}
              mode={mode}
              onSelectSupport={onSelectSupport}
              onSelectHelp={onSelectHelp}
              onSelectMenu={onSelectMenu}
            />
          </div>
        )}
      </div>

      <KycModal
        isOpen={isKycModelOpen}
        setIsOpen={setIsKycModalOpen}
        userId={user?.id}
        userKyc={user?.kyc}
      />
      <ContactSupportModal
        setModalOpen={setIsSupportModalOpen}
        open={isSupportModalOpen}
        user={user}
      />
    </div>
  );
};

export default AppAvatar;
